module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-patients-bucks"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__top"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__image",
    style: ({
      backgroundImage: 'url(' + _vm.props.image + ')'
    })
  }), _c('div', {
    staticClass: "custom-patients-bucks__container"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__container--text"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__title",
    domProps: {
      "innerHTML": _vm._s(_vm.props.title)
    }
  }), _c('div', {
    staticClass: "custom-patients-bucks__subtitle",
    domProps: {
      "innerHTML": _vm._s(_vm.props.subtitle)
    }
  }), _c('div', {
    staticClass: "custom-patients-bucks__tables"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__body--col"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__table"
  }, _vm._l((_vm.props.table), function(table, i) {
    return _c('div', {
      key: i,
      staticClass: "custom-patients-bucks__row"
    }, [_c('div', {
      staticClass: "custom-patients-bucks__col-left"
    }, [_c('div', {
      staticClass: "custom-patients-bucks__item",
      class: {
        'custom-patients-bucks__item--header': i === 0
      },
      domProps: {
        "innerHTML": _vm._s(table.item_left)
      }
    })]), _c('div', {
      staticClass: "custom-patients-bucks__col-right"
    }, [_c('div', {
      staticClass: "custom-patients-bucks__item",
      class: {
        'custom-patients-bucks__item--header': i === 0
      },
      domProps: {
        "innerHTML": _vm._s(table.item_right)
      }
    }, [_c('div', {
      staticClass: "custom-patients-bucks__table--left"
    })])])])
  }), 0)]), _c('div', {
    staticClass: "custom-patients-bucks__body--col"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__table"
  }, _vm._l((_vm.props.table_right), function(table, j) {
    return _c('div', {
      key: j,
      staticClass: "custom-patients-bucks__row"
    }, [_c('div', {
      staticClass: "custom-patients-bucks__col-left"
    }, [_c('div', {
      staticClass: "custom-patients-bucks__item",
      class: {
        'custom-patients-bucks__item--header': j === 0
      },
      domProps: {
        "innerHTML": _vm._s(table.item_left)
      }
    })]), _c('div', {
      staticClass: "custom-patients-bucks__col-right"
    }, [_c('div', {
      staticClass: "custom-patients-bucks__item",
      class: {
        'custom-patients-bucks__item--header': j === 0
      },
      domProps: {
        "innerHTML": _vm._s(table.item_right)
      }
    })])])
  }), 0), _c('div', {
    staticClass: "custom-patients-bucks__body",
    domProps: {
      "innerHTML": _vm._s(_vm.props.body)
    }
  })])])])])]), _c('div', {
    staticClass: "custom-patients-bucks__bottom"
  }, [_c('div', {
    staticClass: "custom-patients-bucks__title custom-patients-bucks__title--bottom",
    domProps: {
      "innerHTML": _vm._s(_vm.props.g_title)
    }
  }), _vm._l((_vm.props.gpeater), function(tile, i) {
    return _c('div', {
      staticClass: "custom-patients-bucks__tile",
      domProps: {
        "innerHTML": _vm._s(tile.body)
      }
    })
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c22a9356","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-patients-bucks/custom-patients-bucks.pug
// module id = 679
// module chunks = 1